<template>
  <div :id="id">
    <div class="cursor-pointer" @click="handleIconClick()">
      <aha-icon
        width="18"
        height="18"
        viewBox="0 0 14 14"
        name="kebab-menu"
      />
    </div>
    <aha-context-menu
      :ref="`context-menu-folder-${folder.folderId}`"
      :target="id"
      :x="targetX"
      :y="targetY"
    >
      <aha-context-menu-header>
        {{ folder.folderName }}
      </aha-context-menu-header>
      <aha-context-menu-item @click="handleRenameFolderItemClick()">
        <aha-svg class="text-base-70" name="edit" />
        <span>Rename</span>
      </aha-context-menu-item>
      <aha-context-menu-item @click="handleDeleteFolderItemClick()">
        <aha-svg class="text-base-70" name="delete" />
        <span>Delete</span>
      </aha-context-menu-item>
    </aha-context-menu>

    <modal-delete-folder
      :folder="folder"
      v-if="isShowingDeleteFolderModal"
      @hide="handleHideDeleteFolderModal()"
    />

    <modal-rename-folder
      :folder="folder"
      v-if="isShowingRenameFolderModal"
      @hide="handleHideRenameFolderModal()"
    />
  </div>
</template>
<script>

// utils
import utils from '@/util'

// constants
import constants from '@/constant'
import EventBus from '@/eventBus'

// modals
import ModalDeleteFolder from '../../modals/DeleteFolder.vue'
import ModalRenameFolder from '../../modals/RenameFolder.vue'

const { gaCategories } = constants

export default {
  components: {
    ModalDeleteFolder,
    ModalRenameFolder,
  },
  props: {
    folder: {
      type: Object,
      default: null,
    },
    id: {
      type: String,
      default() {
        return Math.random().toString().substring(7)
      },
    },
  },
  data() {
    return {
      isShowingRenameFolderModal: false,
      isShowingDeleteFolderModal: false,
      targetX: null,
      targetY: null,
    }
  },
  mounted() {
    EventBus.$on('open-kebab-folder', ({ id, x, y }) => {
      if (id !== this.folder.folderId) {
        return
      }

      this.targetX = x
      this.targetY = y
      this.handleIconClick(true)
    })
  },
  destroyed() {
    EventBus.$off('open-kebab-folder')
  },
  methods: {
    handleDeleteFolderItemClick() {
      this.isShowingDeleteFolderModal = true
      utils.gaTrackEvent(gaCategories.PRESENTATION_LIST, 'Folder Kebab Menu > Delete Folder > Open modal')
    },
    handleIconClick(exact) {
      if (!exact) {
        this.targetX = null
        this.targetY = null
      }

      this.isShowingRenameFolderModal = false
      this.$refs[`context-menu-folder-${this.folder.folderId}`].show()
      utils.gaTrackEvent(
        gaCategories.PRESENTATION_LIST,
        'Folder Kebab Menu > Open',
        null,
        null,
        {
          trigger: exact ? 'contextmenu' : 'click',
        },
      )
    },
    handleHideDeleteFolderModal() {
      this.isShowingDeleteFolderModal = false
      utils.gaTrackEvent(gaCategories.PRESENTATION_LIST, 'Folder Kebab Menu > Delete Folder > Close modal')
    },
    handleHideRenameFolderModal() {
      this.isShowingRenameFolderModal = false
      utils.gaTrackEvent(gaCategories.PRESENTATION_LIST, 'Folder Kebab Menu > Rename Folder > Close modal')
    },
    handleRenameFolderItemClick() {
      this.isShowingRenameFolderModal = true
      utils.gaTrackEvent(gaCategories.PRESENTATION_LIST, 'Folder Kebab Menu > Rename Folder > Open modal')
    },
  },
}
</script>
